// 画面レイアウト
import header from '@/components/organisms/TheHeader'
import footer from '@/components/organisms/TheFooter'
import sidebar from '@/components/organisms/TheSidebar'

// ------------------------------------------------------------
// 個人設定画面
// ------------------------------------------------------------
import AgentSetting from '@/components/pages/prsettings/AgentSetting'
// 個人設定画面：個人タグ管理
import Pvtag from '@/components/pages/prsettings/pvtag/Index'
import PvtagList from '@/components/pages/prsettings/pvtag/List'
import PvtagEdit from '@/components/pages/prsettings/pvtag/Edit'
import ProfileSetting from '@/components/pages/prsettings/ProfileSetting'
import AgentLogin from '@/components/pages/login/AgentLogin'
import PvNisfaIntegrationSettings from '@/components/pages/prsettings/PvNisfaIntegrationSettings'

// ------------------------------------------------------------
// 個人設定画面
// ------------------------------------------------------------
export default [
  // プロフィール変更
  {
    path: '/personal-settings/profile',
    name: 'ProfileSetting',
    meta: {
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: ProfileSetting
    }
  },
  // 代理操作ユーザー指定
  {
    path: '/personal-settings/agents',
    name: 'AgentSetting',
    meta: {
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: AgentSetting
    }
  },
  // 個人タグ管理
  {
    path: '/personal-settings/pvtags',
    components: {
      header,
      sidebar,
      footer,
      content: Pvtag
    },
    children: [
      // 一覧画面
      {
        path: '',
        name: 'pvtag',
        component: PvtagList
      },
      // 作成画面
      {
        path: 'add',
        name: 'pvtag-add',
        meta: {
          isReloadGuardPage: true
        },
        component: PvtagEdit
      },
      // 変更画面
      {
        path: ':id/edit',
        name: 'pvtag-edit',
        meta: {
          isReloadGuardPage: true
        },
        component: PvtagEdit,
        props: true // $route.params.idをpropsに引き渡す
      }
    ]
  },
  // Sales Force Assistant 連携設定
  {
    path: '/personal-settings/nisfa-integration-settings',
    name: 'PvNisfaIntegrationSettings',
    meta: {
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: PvNisfaIntegrationSettings
    }
  },
  // 代理操作
  {
    path: '/agent-login',
    name: 'agent-login',
    components: {
      header,
      sidebar,
      footer,
      content: AgentLogin
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.pset.js